import { create } from 'zustand';
import type { SelectedItemInfo } from '@/services/office/selection';

interface SelectionState {
  items: SelectedItemInfo[];
  setItems: (items: SelectedItemInfo[]) => void;
  clear: () => void;
}

export const useSelectionStore = create<SelectionState>((set) => ({
  items: [],
  setItems: (items) => set({ items }),
  clear: () => set({ items: [] }),
}));
